import Apartment from "../model/Apartment";
import Product from "../model/Product";
import SpaceData from "../model/productData/SpaceData";
import ApartmentViewModel from "../viewModels/ApartmentViewModel";
import { UUID } from "./typeDefinitions";

const spaceBelongsToApartment = (space: Product, apartmentId: UUID) : boolean => {
    if (space.productData instanceof SpaceData) {
        const spaceData = space.productData as SpaceData;
        return spaceData.apartmentId === apartmentId;
    }

    return false;
}

const buildApartmentViewModels = (apartments: Apartment[], spaces: Product[]) : ApartmentViewModel[] => {

    const result = apartments.reduce<ApartmentViewModel[]>((acc, apartment) => {
        const relatedSpaces = spaces.filter(space => spaceBelongsToApartment(space, apartment.globalId));
        acc.push(new ApartmentViewModel(apartment, relatedSpaces));
        return acc;
    }, []);

    return result;
}

export { buildApartmentViewModels }